import { Menu, MenuButton, MenuItem } from "@szhsin/react-menu";
import { logoutAdmin } from "../../../Redux/Auth/AuthActions";
import { AppDispatch } from "../../../Redux/store";
import { RootState } from "../../../Redux/store";
import Logo from "../../../Assets/Logo.png";
import { FaRegBell } from "react-icons/fa";
import styles from "./Header.module.scss";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Link } from "react-router";
function Header() {
  const { admin, adminToken } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch<AppDispatch>();
  return (
    <div className={styles.mainContainer}>
      <Link to="/admin" className={styles.logoContainer}>
        <img src={Logo} alt="logo" className={styles.logo} />
      </Link>
      {!admin && !adminToken && (
        <div className={styles.menuContainer}>
          <Link className={styles.loginButton} to="/login" replace>
            Login
          </Link>
        </div>
      )}
      {admin && adminToken && (
        <div className={styles.menuContainer}>
          <div className={styles.notificationContainer}>
            <FaRegBell className={styles.icon} />
          </div>

          <Menu
            menuButton={
              <MenuButton>
                <div className={styles.menuItem}>
                  {admin && (
                    <p>
                      {admin?.name?.split(" ")[0][0] +
                        admin?.name?.split(" ")[1][0]}
                    </p>
                  )}
                </div>
              </MenuButton>
            }
            transition
          >
            <MenuItem onClick={() => dispatch(logoutAdmin())}>Logout</MenuItem>
          </Menu>
        </div>
      )}
    </div>
  );
}

export default Header;
